import React from 'react';
import hero from '../assets/hero.png';
import tab1 from '../assets/tab1.png';
import tab2 from '../assets/tab2.png';
import b1 from '../assets/b1.png';
import b2 from '../assets/b2.png';
import b3 from '../assets/b3.png';
import b4 from '../assets/b4.png';

const MobileHomePage = () => {

  return (
    <div className="text-center px-4 w-full">
      {/* Hero Image */}
      <div className="w-full mt-20 px-4">
        <img 
          src={hero} 
          alt="hero" 
          className="w-full h-auto object-contain block"
        />
        
       <p
  className="text-gray-300 leading-tight"
  style={{
    fontFamily: 'Space Grotesk',
    fontWeight: '500',
    textAlign: 'left',
    fontSize: '22px',
    lineHeight: '32px',
  }}
>
  Global Independent Design Studio
  for AI Startups
</p>
      </div>

      {/* Brands Trust Text */}
      <div className="w-full px-4 mt-24">
        <div 
          className="text-gray-300 text-xs tracking-widest mb-4"
          style={{
            fontFamily: 'Space Grotesk',
            fontWeight: '500',
            fontSize: '16px',
            textAlign: 'left',
            lineHeight: '24px',
            letterSpacing: '0.1em',
          }}
        >
          <span>BRANDS WHO TRUST OUR CLARITY-FIRST DESIGN</span><br />
        </div>
        

        {/* Brand Logos */}
        <div className="flex flex-wrap justify-start items-center gap-x-8 gap-y-6 mb-16">
          <img src={b1} alt="brands" className="w-[134px] h-[41px]" />
          <img src={b2} alt="brands" className="w-[98px] h-[24px]" />
          <img src={b3} alt="brands" className="w-[117px] h-[48px]" />
          <img src={b4} alt="brands" className="w-[108px] h-[43px]" />
        </div>
      </div>

      {/* Mobile Main Content */}
      <div className="px-4">
        {/* Main Title */}
        <div className="mb-8 mt-24 text-left">
          <p
            style={{
              fontFamily: 'Bricolage Grotesque',
              fontWeight: '300',
              fontSize: '30px',
              lineHeight: '32px',
              letterSpacing: '-0.01em',
            }}
          >
            The Design Studio<br />
            That Actually Delivers
          </p>
          <p
            style={{
              fontFamily: 'Bricolage Grotesque',
              fontWeight: '500',
              fontSize: '30px',
              lineHeight: '32px',
              letterSpacing: '-0.01em',
            }}
          >
            <span className="text-white">From Not Working to</span> {' '}
            <span className="text-white">That Works</span>
          </p>
        </div>

        {/* Mobile Tabs - Stacked */}
        <div className="space-y-4">
          {/* Quick Win Sprint Card */}
          <div 
            className="rounded-t-3xl p-6 pb-0 relative overflow-hidden text-left"
            style={{
              background: 'rgba(111, 67, 254, 1)',
            }}
          >
            {/* Quick Win Sprint Tag */}
            <div 
              className="inline-block mb-4 align-middle"
              style={{
                background: '#EAF727',
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '-0.02em',
                color: '#000',
                padding: '8px 16px',
                borderRadius: '8px',
                verticalAlign: 'middle',
              }}
            >
              Quick Win Sprint
            </div>

            {/* Main Heading */}
            <h3 
              className="text-white leading-tight mb-4"
              style={{
                fontFamily: 'Bricolage Grotesque',
                fontWeight: '500',
                fontSize: '30px',
                lineHeight: '32px',
                letterSpacing: '-0.01em',
              }}
            >
             Let's fix your confusing website 
            </h3>

            {/* Description */}
            <p 
              className="mb-6"
              style={{
                fontFamily: 'Space Grotesk',
                fontWeight: 400,
                fontSize: '20px',
                color: 'rgba(255, 255, 255, 1)',
                lineHeight: '24px',
                letterSpacing: '-0.02em',
              }}
            >
              We sharpen your story, build trust, and design a website that turns visitors into customers
            </p>

            {/* CTA Button */}
            <button 
            onClick={() => window.open('https://cal.com/payandesign/quickwinsprint', '_blank')}
              className="text-white bg-black mb-4 capitalize"
              style={{
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                fontSize: '20px',
                lineHeight: '100%',
                letterSpacing: '0%',
                borderRadius: '10px',
                width: '252px',
                height: '67px',
                padding: '18px 34px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
              }}
            >
              See What We Fix
            </button>

            {/* Image */}
            <div className="mt-6 overflow-hidden" style={{ borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
              <img 
                src={tab1} 
                alt="Quick Win Sprint Example"
                style={{
                  width: '100%',
                  height: '293px',
                  objectFit: 'cover',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                }}
              />
            </div>
          </div>

          {/* Design Partner Plan Card */}
          <div 
            className="rounded-t-3xl p-6 pb-0 relative overflow-hidden text-left"
            style={{
              background: '#EAF727',
              minHeight: '650px',
              marginTop: '32px',
            }}
          >
            {/* Tab Indicator */}
            <div 
              className="inline-block mb-4 align-middle"
              style={{
                background: '#6F43FE',
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                fontSize: '16px',
                lineHeight: '24px',
                letterSpacing: '-0.02em',
                color: '#fff',
                padding: '8px 16px',
                borderRadius: '8px',
                verticalAlign: 'middle',
              }}
            >
              Design Partner Plan
            </div>

            {/* Main Heading - 3 lines */}
            <h3
              className="text-black mb-4"
              style={{
                fontFamily: 'Bricolage Grotesque',
                fontWeight: 500,
                fontSize: '30px',
                lineHeight: '32px',
                letterSpacing: '-0.01em',
                verticalAlign: 'middle',
              }}
            >
              Marketing<br />
              Assets Waiting<br />
              on design?
            </h3>

            {/* Description - single line */}
            <p
              className="mb-6"
              style={{
                fontFamily: 'Space Grotesk',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '24px',
                color: 'rgba(0, 0, 0, 1)',
                letterSpacing: '-0.02em',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              Get all your design tasks done with one monthly subscription. Unlimited creatives, delivered weekly
            </p>

            {/* CTA Button */}
            <button
             onClick={() => window.open('https://cal.com/payandesign/designpartner', '_blank')}
              className="mb-4 capitalize"
              style={{
                fontFamily: 'Space Grotesk',
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '100%',
                letterSpacing: '0%',
                width: '252px',
                height: '67px',
                textWrap: 'nowrap',
                borderRadius: '10px',
                paddingTop: '18px',
                paddingRight: '34px',
                paddingBottom: '18px',
                paddingLeft: '34px',
                gap: '10px',
                backgroundColor: '#000',
                color: '#fff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              Fix Your Backlog Now
            </button>

            {/* Tab Image */}
            <div
              className="mt-6 overflow-hidden"
              style={{
                borderTopLeftRadius: '20px',
                borderTopRightRadius: '20px',
              }}
            >
              <img
                src={tab2}
                alt="Design Partner Plan Example"
                style={{
                  width: '100%',
                  height: '284px',
                  objectFit: 'cover',
                  borderTopLeftRadius: '20px',
                  borderTopRightRadius: '20px',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileHomePage;